
import { SortOption } from "./SortButton";
import { useTranslation } from "@/hooks/useTranslation";
import { Button } from "@/components/ui/button";

interface MobileInventoryContentProps<T> {
  data: T[];
  sortField: string;
  sortOrder: 'asc' | 'desc';
  onSort: (field: string) => void;
  onSortOrderChange: () => void;
  onActionComplete: () => void;
  renderItem: (item: T, index: number) => React.ReactNode;
  sortOptions: SortOption[];
  showTransfer?: boolean;
}

export function MobileInventoryContent<T>({
  data,
  sortField,
  sortOrder,
  onSort,
  onSortOrderChange,
  onActionComplete,
  renderItem,
  sortOptions,
  showTransfer
}: MobileInventoryContentProps<T>) {
  const { t } = useTranslation();
  
  return (
    <div>
      <div className="space-y-3 mt-3 pb-20"> {/* Added padding bottom for mobile nav */}
        {data.length === 0 ? (
          <div className="text-center py-10 text-muted-foreground">
            {t('no_items_inventory')}
          </div>
        ) : (
          data.map((item, index) => (
            <div key={index} className="fade-in" style={{animationDelay: `${index * 50}ms`}}>
              {renderItem(item, index)}
            </div>
          ))
        )}
      </div>
    </div>
  );
}
